<div style="display: flex">
    <div class="snackbar content" [innerHtml]="data">
    </div>
    <div style="margin-left: 12px;">
        <span appOcticon octicon="x" width="16" (click)="close()" color="#ffffff" style="cursor: pointer"></span>
    </div>
</div>


